import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCreditScores, type Person } from '../data/useCreditScores';
import { useHousehold } from '../auth/useHousehold';
import { getPersonName } from '../config/personNames';
import { CreditScoreModal } from './CreditScoreModal';
import { CreditScoreDonut } from './CreditScoreDonut';

const HISTORY_HREF = '/net-worth?tab=credit';

export function CreditStrip() {
  const credit = useCreditScores();
  const household = useHousehold();
  const [searchParams] = useSearchParams();
  const forceStale = searchParams.get('reminderDebug') === '1';
  const [modalOpen, setModalOpen] = useState(false);

  const add = credit.status === 'ready' ? credit.add : null;

  // Identify which person key the signed-in user owns so we only render the
  // per-card "Add score" CTA on their own card. Returns null in demo / locked
  // / unknown-email cases — both cards then read-only on the dashboard.
  const selfPerson: Person | null =
    household.status === 'ready' && household.selfId != null
      ? household.ids.dakota === household.selfId
        ? 'dakota'
        : household.ids.natalia === household.selfId
          ? 'natalia'
          : null
      : null;

  return (
    <>
      <div className="grid grid-cols-2 gap-5 max-md:grid-cols-1">
        <CreditScoreDonut
          person="dakota"
          entries={credit.data.dakota}
          isSelf={selfPerson === 'dakota'}
          forceStale={forceStale}
          onAddClick={() => setModalOpen(true)}
          href={HISTORY_HREF}
        />
        <CreditScoreDonut
          person="natalia"
          entries={credit.data.natalia}
          isSelf={selfPerson === 'natalia'}
          forceStale={forceStale}
          onAddClick={() => setModalOpen(true)}
          href={HISTORY_HREF}
        />
      </div>

      {modalOpen && add && (
        <CreditScoreModal
          personLabel={selfPerson ? getPersonName(selfPerson) : 'Your entry'}
          onSubmit={async (input) => {
            await add(input);
          }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
